// Reports filter form: "Single Date" hides the To Date field and keeps it
// in sync with From Date (so the range submitted is just that one day); the
// server also normalizes this itself (see Admin::ReportsController) in case
// JS never runs.
document.addEventListener('turbolinks:load', function () {
  var form = document.getElementById('reports-filter-form')
  if (!form) return

  var toDateField = document.getElementById('to_date_field')
  var fromDateInput = form.querySelector('#report_from_date')
  var toDateInput = form.querySelector('#report_to_date')

  function apply() {
    var single = form.querySelector('#filter_by_single').checked
    toDateField.hidden = single
    if (single) toDateInput.value = fromDateInput.value
  }

  form.querySelectorAll('input[name="report[filter_by]"]').forEach(function (radio) {
    radio.addEventListener('change', apply)
  })
  fromDateInput.addEventListener('change', apply)

  apply()
})
